<template>
  <v-card>
    <!-- <v-card-title>
      <T>Состояние подключения</T>
    </v-card-title> -->
    <v-card-text v-if="error_message">
      <InfoField :loading="local_loading" :label="$t('Состояние подключения')">
        <T style="color: var(--v-error-base)">Отключено</T>
      </InfoField>
      <InfoField :loading="local_loading" :label="$t('Ошибка')">
        <span style="color: var(--v-error-base)">{{error_message}}</span>
      </InfoField>
    </v-card-text>
    <v-card-text v-else>
      <InfoField :loading="local_loading" :label="$t('Состояние подключения')">
        <T style="color: var(--v-primary-base)">Подключено</T>
      </InfoField>
      <InfoField :loading="local_loading" :label="$t('Сервер')">
        {{ ping.mid_name || 'asdf' }}
      </InfoField>
      <InfoField :loading="local_loading" :label="$t('Версия')">
        {{ ping.mid_version || 'asdf' }}
      </InfoField>
    </v-card-text>
  </v-card>
</template>

<script>
import InfoField from '../../common/InfoField.vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    local_loading: false,
    error_message: 'Что такое что случилось как такое получилось, почему вообще мы должны с вами это обсуждать, этож просто ничего себе какая неожиданность'
  }),
  computed: {
    ...mapGetters(['ping'])
  },
  methods: {
    async pingNow(){
      this.local_loading = true
      this.error_message = ''
      try {
        await this.$store.dispatch('globalPing')
      } catch (e) {
        this.error_message = e.message
      } finally {
        this.local_loading = false
      }
    }
  },
  async mounted(){
    await this.pingNow()
  },
  components: {
    InfoField
  }
}
</script>